import e from"styled-components";import{CONTENT_POSITION as o,COLOR_CONFIG_MAP as t}from"./AlertHelper.js";const r=e.div`
	display: flex;
	align-items: center;
	justify-content: ${e=>e.contentPosition||o.CENTER};
	padding: 8px 16px;
	background-color: ${e=>t[e.type].backgroundColor};
	border-radius: 4px;
	border: 1px solid ${e=>t[e.type].borderColor};
`,i=e.div`
	flex: 1;
	display: flex;
	justify-content: center;
`,n=e.div`
	margin-left: 16px;
	display: flex;
	align-items: center;
`;export{i as AlertContentWrapper,r as AlertStyle,n as CloseIconWrapper};
